// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-container .alert-text[data-v-3cf10806] {\n  color: #E9A021;\n  cursor: default;\n}\n.home-container .thumbnail-img[data-v-3cf10806] {\n  width: 80px;\n  height: 80px;\n  position: relative;\n}\n.home-container .thumbnail-img img[data-v-3cf10806] {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
